module.exports = __webpack_public_path__ + "img/general-trading2.568f9d99.jpg";